import React, { useState, useEffect } from "react";
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import DownloadIcon from '@mui/icons-material/Download';
import Trash from '../../../assets/trash.png';
import Edit from '../../../assets/edit_pen.png';
import "./ModuleItem.scss";
import { MenuItem } from "@mui/material";
import Button from "../../controls/buttons/Button";
import TextField from '@mui/material/TextField';

function ClasseItem({ aula, admin, index, modIndex, handleEdit, handleDelete, viewClass }) {



    const [expand, setExpand] = useState(false);
    const [edit, setEdit] = useState(false);
    const [className, setClassName] = useState(aula.name);
    const [classDesc, setClassDesc] = useState(aula.classDesc);
    const [classLink, setClassLink] = useState(aula.classLink);
    const [classDraft, setClassDraft] = useState(aula.draft);
    const [classFiles, setClassFiles] = useState([...aula.classFiles]);
    const [classContent, setClassContent] = useState([...aula.classContent]);
    const [classContentTemp, setClassContentTemp] = useState("");

    function formatFileSize(bytes, decimalPoint) {
        if (bytes == 0) return '0 Bytes';
        var k = 1000,
            dm = decimalPoint || 2,
            sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }


    function cancelEdit() {
        setClassName(aula.name);
        setClassDesc(aula.classDesc);
        setClassDraft(aula.draft);
        setClassLink(aula.classLink);
        setClassFiles([...aula.classFiles]);
        setClassContent([...aula.classContent]);
        setClassContentTemp("")
        setEdit(false)
    };


    function toggleAcordion() {
        setExpand((prev) => !prev);
    };

    function validateURL(link) {
        if (link.indexOf("http://") == 0 || link.indexOf("https://") == 0) {
            return (link)
        }
        else {
            return ("https://" + link)
        }
    }

    function renderAulaDetails() {
        return (
            <div >
                <div className="aula-details">
                    <label>Link da aula</label>
                </div>
                <div className="aula-details">
                    <a href={validateURL(aula.classLink)} target="_blank" rel="noreferrer noopener">
                        {aula.classLink}
                    </a>
                </div>
                <hr className="line-break" />
                <div className="aula-details">
                    <label>Materiais</label>
                </div>

                {renderFiles()}
                {renderLinks()}
            </div>

        )
    }

    function downloadFile(link, name) {
        try {
            var xhr = new XMLHttpRequest();
            xhr.responseType = 'blob';
            xhr.onload = function (event) {
                //Create an `a` tag (since it has an `href` and a `download` attribute) 
                var a = document.createElement('a');
                a.href = window.URL.createObjectURL(xhr.response);
                a.download = name;
                a.style.display = 'none';
                document.body.appendChild(a);
                a.click();                            //Simulates a click event
                var blob = xhr.response;
            };
            xhr.open('GET', link);
            xhr.send();

        }
        catch (errors) {
            console.log(errors);
        }
    }

    function renderLinksEdit() {
        let array = [...classContent];
        let files = [];
        array.forEach((el, index) => {

            files.push(
                <div className="file-div">
                    <div className="file-div-left">
                        <a href={validateURL(el)} target="_blank" rel="noreferrer noopener">
                            {el}
                        </a>
                    </div>
                    <div className="file-div-right">
                        <img src={Trash} onClick={() => deleteClassContent(index)} />
                    </div>
                </div>
            )


        });
        return files;
    }

    function deleteClassContent(index) {
        let array = [...classContent];
        array.splice(index, 1);
        setClassContent(array);
    }

    function addClassContent() {
        if (classContentTemp != "") {
            let array = [...classContent];
            array.push(classContentTemp);
            setClassContent(array);
            setClassContentTemp("")
        }

    }

    function deleteClassFile(index) {
        let array = [...classFiles];
        array.splice(index, 1);
        setClassFiles(array);
    }

    function addClassFile(element) {
        let file = element && element.target && element.target.files ? element.target.files[0] : null;
        if (!file) {
            return;
        }
        if (file.size > 20000000) {
            alert('O tamanho do arquivo ultrapassa o limite máximo de 20Mb permitido.', 'error');
            return;
        }

        let array = [...classFiles];
        array.push(file)
        setClassFiles(array);
        element.target.value = null;
    }

    function renderClassFiles() {
        let array = [...classFiles];
        let files = []
        array.forEach((el, index) => {
            files.push(
                <div className="file-div">
                    <div className="file-div-left">
                        <label> {el.name}</label>
                    </div>
                    <div className="file-div-right">
                        <label>{formatFileSize(el.size)}</label>
                        <img src={Trash} onClick={() => deleteClassFile(index)} />
                    </div>
                </div>

            )
        });
        return files;
    }

    function editAula() {
        let newAula = { ...aula };
        newAula.name = className;
        newAula.draft = classDraft;
        newAula.classDesc = classDesc;
        newAula.classLink = classLink;
        newAula.classFiles = classFiles;
        newAula.classContent = classContent;

        handleEdit(newAula, modIndex, index);
        setEdit(false);

    }

    function renderFiles() {
        let array = aula.classFiles;
        let files = [];
        array.forEach(el => {
            if (el.link) {
                files.push(
                    <div className="file-div">
                        <div className="file-div-left">
                            <label> {el.name}</label>
                        </div>
                        <div className="file-div-right">
                            <label>{formatFileSize(el.size)}</label>
                            <DownloadIcon onClick={() => downloadFile(el.link, el.name)} />
                        </div>
                    </div>
                )
            }
            else {
                files.push(
                    <div className="file-div">
                        <div className="file-div-left">
                            <label> {el.name}</label>
                        </div>
                        <div className="file-div-right">
                            <label>{formatFileSize(el.size)}</label>
                        </div>
                    </div>
                )
            }

        });
        return files;
    }


    function renderLinks() {
        let array = aula.classContent;
        let files = [];
        array.forEach(el => {
            if (el.link) {
                files.push(
                    <div className="file-div">
                        <div className="file-div-left">
                            <a href={validateURL(el)} target="_blank" rel="noreferrer noopener">
                                {el}
                            </a>
                        </div>
                    </div>
                )
            }

        });
        return files;
    }

    return (
        <div className="accordion-container">
            <Accordion expanded={expand}>
                <>
                    <div className="classe-div">

                        <div className="classe-div-left">
                            <DragIndicatorIcon />
                            <label onClick={viewClass}> Aula {index + 1}: {aula.name}</label>
                            {admin && <img src={Edit} onClick={() => setEdit(true)} />}
                            {admin && <img src={Trash} onClick={handleDelete} />}
                        </div>
                        <div className="module-div-right">
                            <label>{admin ? aula.draft ? "Rascunho" : "Publicado" : ''}</label>
                            <KeyboardArrowDownIcon onClick={() => toggleAcordion()} />
                        </div>

                    </div>
                    {edit &&
                        <div className="aula-edit">
                            <div >
                                <TextField
                                    type="text"
                                    value={className}
                                    label="Nome da Aula"
                                    name="name"
                                    id="name"
                                    className="Module-name-field"
                                    enterKeyHint="done"
                                    onChange={event => setClassName(event.target.value)}
                                />
                            </div>
                            <div>
                                <TextField
                                    type="text"
                                    rows="4"
                                    multiline
                                    value={classDesc}
                                    label="Descrição da Aula"
                                    className="Subject-description-field-fixed"
                                    placeholder="Adicione uma descrição à aula (opcional)"
                                    name="description"
                                    id="description"
                                    enterKeyHint="done"
                                    onChange={event => setClassDesc(event.target.value)}
                                />
                            </div>
                            <div className="aula-details">
                                <label>Link da aula</label>
                            </div>
                            <div >
                                <TextField
                                    type="text"
                                    value={classLink}
                                    label="Link da Aula"
                                    name="name"
                                    id="name"
                                    className="Module-name-field"
                                    enterKeyHint="done"
                                    onChange={event => setClassLink(event.target.value)}
                                />
                            </div>
                            <hr className="line-break-edit" />
                            <div className="aula-details">
                                <label>Materiais da aula</label>
                            </div>
                            {renderClassFiles()}
                            {renderLinksEdit()}
                            <div className="new-file-btn">
                                <div className="class-btn-file">
                                    <Button className={'primary-button'}>
                                        <span>+ Novo Arquivo</span>
                                    </Button>
                                    <input type="file" onChange={addClassFile} accept="image/*,.pdf,video/* ,.doc,.docx,.ppt, .pptx " />
                                </div>
                                <label >
                                    *Tamanho máximo do arquivo 20mb
                                </label>

                            </div>
                            <div className="new-modules-btn">
                                <TextField
                                    type="text"
                                    value={classContentTemp}
                                    label={"Link"}
                                    placeholder="Insira aqui o link do material"
                                    InputLabelProps={{ shrink: true }}
                                    name="name"
                                    id="name"
                                    className="Module-link-field"
                                    enterKeyHint="done"

                                    onChange={(event) => setClassContentTemp(event.target.value)}
                                />
                                <label onClick={() => addClassContent()}>
                                    <Button className={'primary-button input-button'}>
                                        <span>+ Novo Link</span>
                                    </Button>
                                </label>

                            </div>
                            <hr className="line-break-edit" />
                            <div >
                                <TextField
                                    select className="Module-name-select"
                                    value={classDraft}
                                    placeholder="Nome do Módulo"
                                    name="name"
                                    id="name"
                                    enterKeyHint="done"
                                    onChange={event => setClassDraft(event.target.value)}
                                >
                                    <MenuItem value={true}> Rascunho </MenuItem>
                                    <MenuItem value={false}> Publicado </MenuItem>
                                </TextField>
                            </div>
                            <div>
                                <div className="edit-modules-btn">

                                    <label onClick={() => editAula()}>
                                        <Button className="primary-button">
                                            <span>Salvar alterações</span>
                                        </Button>
                                    </label>
                                    <label onClick={() => cancelEdit()}>
                                        <Button className={'white-button'}>
                                            <span>Cancelar</span>
                                        </Button>
                                    </label>

                                </div>
                            </div>

                        </div>}
                </>

                <AccordionDetails>
                    {renderAulaDetails()}
                </AccordionDetails>

            </Accordion>
        </div>

    );
}

export default ClasseItem;